import { StyleCard } from "../ui/StyleCard"
import { useTranslation } from "react-i18next"
import { Icon } from "../icons/Icon"
import { StyleResponseDTO } from "@/api/dto/styles"

export type StylesListType = "display" | "select"

export function StylesList(props: {
	type: StylesListType
	styles: StyleResponseDTO[]
	selectedStyle?: StyleResponseDTO
	onSelect?: (style: StyleResponseDTO) => void
	onAddNew?: () => void
	isFullWidth?: boolean
	onViewClicked?: (style: StyleResponseDTO) => void
}) {
	const gridClassName = props.isFullWidth
		? "grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xxl:grid-cols-6"
		: "grid-cols-4 gap-4"

	const renderStyleCard = (style: StyleResponseDTO) => {
		return (
			<StyleCard
				key={style.styleId}
				style={style}
				isSelected={props.type === "select" && style === props.selectedStyle}
				onSelect={props.onSelect}
				onViewClicked={props.onViewClicked}
			/>
		)
	}

	return (
		<div className={`grid ${gridClassName}`}>
			{props.onAddNew && <AddStyleCard onAddNew={props.onAddNew} />}
			{props.styles.map((style) => renderStyleCard(style))}
		</div>
	)
}

const AddStyleCard = (props: { onAddNew: () => void }) => {
	const { t } = useTranslation("components")
	return (
		<div
			role="button"
			aria-label={t("stylesList.ariaCreateNewAIStyle")}
			className="flex w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-base-700 hover:bg-base-600"
			onClick={props.onAddNew}
		>
			<Icon aria-hidden name="add" size={30} />
			<div aria-hidden className="text-sm font-semibold">
				{t("stylesList.createAiStyle")}
			</div>
		</div>
	)
}

export default StylesList
